import { Grid } from "@mui/material";
import { PropsWithChildren } from "react";

type Props = {};

const Timeslot = ({ children }: PropsWithChildren<Props>) => {
  return (
    <Grid
      sx={{
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "20px",
        ":first-child": {
          marginTop: "-12px",

          // display: "none",
        },
      }}
      display={"flex"}
      flex={1}
      alignItems={"center"}
    >
      {children}
    </Grid>
  );
};

export default Timeslot;
